module.exports = "img/flags/BN.fec59b5.png";